import React, { useState, useEffect, useRef } from "react";

import {
    Grid,
    Paper,
    Typography,
    TextField,
    Button,
    InputAdornment,
    makeStyles,
    Hidden
} from "@material-ui/core";

import {
    Receipt,

    AccountBalanceWallet,
    AccessTime,
    TrendingUp,
    LocalAtm,
    AccountBalance,
    MonetizationOn,
    Security,
    Person,
    Description,
    CheckCircle,
    Store,
    CloudUpload
} from "@material-ui/icons";
import { sto } from "../../../../Context/InshData";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { useTranslation } from "react-i18next";
import { menuBottonsMultiFile } from "../components/SearchItemsFunction";
import RestInfoDialog from "../models/RestInfo/RestInfoDialog";

// =====================================
// ألوان الأنظمة
// =====================================

const SYSTEM_THEMES = {

    sales: {
        primary: "#07966B",
        secondary: "#13B981",
        light: "#E9F8F0",
        soft: "#F2FBF6",
        icon: "#07966B",
        total: "linear-gradient(120deg,#20AD65,#00875A)",
        name: "المبيعات"
    },

    purchases: {
        primary: "#079da4",
        secondary: "#079da4",
        light: "#def7f7",
        soft: "#def7f7",
        icon: "#007e86",
        total: "linear-gradient(120deg,#079da4,#079da4)",
        name: "المشتريات"
    },
    eshar: {
        primary: "#FF1493",
        secondary: "#FF1493",
        light: "#FFF3E2",
        soft: "#FFFAF2",
        icon: "#D98216",
        total: "linear-gradient(120deg,#FF1493,#FF1493)",
        name: "المشتريات"
    },
    qoutation: {
        primary: "#964B00",
        secondary: "#964B00",
        light: "#FFF3E2",
        soft: "#FFFAF2",
        icon: "#D98216",
        total: "linear-gradient(120deg,#964B00,#964B00)",
        name: "المشتريات"
    },
    openingStock: {
        primary: "#7653C6",
        secondary: "#9475E5",
        light: "#F0EBFF",
        soft: "#F8F5FF",
        icon: "#7653C6",
        total: "linear-gradient(120deg,#9270E8,#6541B5)",
        name: "مخزون أول مدة"
    },

    salesReturn: {
        primary: "#D94C52",
        secondary: "#EF7070",
        light: "#FDEBEC",
        soft: "#FFF6F6",
        icon: "#D94C52",
        total: "linear-gradient(120deg,#E76B70,#C93642)",
        name: "مرتجع المبيعات"
    },

    purchaseReturn: {
        primary: "#D66B35",
        secondary: "#EB8953",
        light: "#FFF0E8",
        soft: "#FFF8F4",
        icon: "#D66B35",
        total: "linear-gradient(120deg,#EA8952,#C75B2D)",
        name: "مرتجع المشتريات"
    }

};

// =====================================
// تنسيق الأرقام
// =====================================

const formatNumber = (value) => {

    return Number(value || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

};

// =====================================
// Styles
// =====================================

const useStyles = makeStyles((theme) => ({

    container: {
        padding: 12,
        background: "#FFFFFF",
        border: "1px solid #E5EAF2",
        borderRadius: 12,
        boxShadow: "0 4px 15px rgba(30,50,80,0.06)",
        direction: "rtl",
        width: "100%",
        boxSizing: "border-box"
    },

    card: {
        height: "100%",
        padding: "10px 11px",
        borderRadius: 12,
        border: "1px solid #E9EDF3",
        background: "#FFFFFF",
        boxShadow: "0 2px 7px rgba(0,0,0,0.045)",
        transition: "all .2s ease",
        "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 5px 13px rgba(0,0,0,0.08)"
        }
    },

    cardHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 5,
        marginBottom: 9,
        minHeight: 24
    },

    cardTitle: {
        fontSize: 14,
        fontWeight: 800,
        color: "#24344D",
        whiteSpace: "nowrap"
    },

    icon: {
        fontSize: 20
    },

    value: {
        height: 39,
        border: "1px solid #E0E5EC",
        borderRadius: 7,
        display: "flex",
        alignItems: "center",
        padding: "0 10px",
        justifyContent: "flex-start",
        background: "#FAFBFD",
        fontSize: 17,
        fontWeight: 800,
        color: "#17243A"
    },

    input: {
        "& .MuiOutlinedInput-root": {
            height: 39,
            borderRadius: 7,
            background: "#FAFBFD",
            fontWeight: 800,
            fontSize: 16
        },
        "& .MuiOutlinedInput-input": {
            textAlign: "left",
            padding: "8px 10px"
        }
    },

    finalCard: {
        height: "100%",
        minHeight: 80,
        borderRadius: 13,
        padding: "12px 18px",
        background: (props) => props.colors.total,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "#FFFFFF",
        boxShadow: "0 4px 12px rgba(0,0,0,0.13)"
    },

    finalTitle: {
        fontSize: 19,
        fontWeight: 900
    },

    finalValue: {
        fontSize: 30,
        fontWeight: 900,
        direction: "ltr"
    },

    balanceCard: {
        height: "100%",
        minHeight: 80,
        background: "#EFF6FF",
        border: "1px solid #D7E7FF",
        borderRadius: 12,
        padding: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        color: "#1768CE"
    },

    balanceButton: {
        height: 80,
        borderRadius: 10,
        background: "#B9DEFA",
        color: "#174C87",
        fontWeight: 800,
        fontSize: 14,
        boxShadow: "0 3px 7px rgba(0,0,0,.15)",
        "&:hover": {
            background: "#A3D1F5"
        }
    },

    userCard: {
        minHeight: 80,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: 12,
        borderRadius: 12,
        background: "#F7F9FC",
        border: "1px solid #E9EDF3",
        textAlign: "center"
    },

    userText: {
        color: "#1754A0",
        fontWeight: 800,
        fontSize: 14,
        lineHeight: 1.8
    },

    netCard: {
        background: (props) => props.colors.light,
        borderColor: (props) => props.colors.primary
    },

    discountCard: {
        background: (props) => props.colors.soft
    }

}));

// =====================================
// مكون بطاقة الإجمالي
// =====================================

const SummaryCard = ({
    title,
    value,
    icon: Icon,
    colors,
    net = false
}) => {

    const classes = useStyles({ colors });

    return (

        <Paper
            className={`${classes.card} ${net ? classes.netCard : ""}`}
            elevation={0}
        >

            <div className={classes.cardHeader}>

                <Typography className={classes.cardTitle}>
                    {title}
                </Typography>

                {Icon && (
                    <Icon
                        className={classes.icon}
                        style={{ color: colors.icon }}
                    />
                )}

            </div>

            <div className={classes.value}>
                {formatNumber(value)}
            </div>

        </Paper>

    );

};

// =====================================
// مكون الخصم القابل للتعديل
// =====================================

const DiscountCard = ({
    title,
    amount,
    percentage,
    onAmountChange,
    onPercentageChange,
    changClick,
    permistionInv,
    isHedden,
    colors,
    icon: Icon
}) => {

    const classes = useStyles({ colors });

    return (

        <Paper
            className={`${classes.card} ${classes.discountCard}`}
            elevation={0}
        >

            <div className={classes.cardHeader}>

                <Typography className={classes.cardTitle}>
                    {title}
                </Typography>

                {Icon && (
                    <Icon
                        style={{
                            color: colors.icon,
                            fontSize: 20
                        }}
                    />
                )}

            </div>

            <Grid container spacing={1}>
                <Grid item xs={6}>

                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        label={"المبلغ"}
                        value={amount}
                        onClick={() => changClick("minus", false)}
                        disabled={
                            isHedden ? true :
                                (permistionInv.APDC === 2 || permistionInv.APDC === 3) && permistionInv.DSOB == 1
                                    ? false
                                    : true
                        }
                        onChange={onAmountChange}
                        className={classes.input}
                    // placeholder="المبلغ"
                    />

                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={percentage}
                        label={"%"}
                        onClick={() => changClick("rate", false)}
                        disabled={
                            isHedden ? true :
                                (permistionInv.APDC === 1 || permistionInv.APDC === 3) && permistionInv.DSOB == 1
                                    ? false
                                    : true
                        }
                        onChange={onPercentageChange}
                        placeholder="%"
                        className={classes.input}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">

                                </InputAdornment>
                            )
                        }}
                    />

                </Grid>

            </Grid>

        </Paper>

    );

};

const TotalsCard = ({
    title,
    value,
    onchange,
    colors,
    disabled,
    icon: Icon
}) => {

    const classes = useStyles({ colors });

    return (
        <Paper
            className={`${classes.card} ${classes.discountCard}`}
            elevation={0}
        >
            <div className={classes.cardHeader}>
                <Typography className={classes.cardTitle}>
                    {title}
                </Typography>
                {Icon && (
                    <Icon
                        style={{
                            color: colors.icon,
                            fontSize: 20
                        }}
                    />
                )}

            </div>

            <Grid container>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={value}
                        onChange={onchange}
                        className={classes.input}
                        disabled={disabled}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">

                                </InputAdornment>
                            )
                        }}
                    />

                </Grid>

            </Grid>

        </Paper>

    );

};

const NotesCard = ({
    title,
    value,
    colors,
    changIdata,
    icon: Icon
}) => {

    const classes = useStyles({ colors });

    return (

        <Paper
            className={`${classes.card} ${classes.discountCard}`}
            elevation={0}
        >
            <div className={classes.cardHeader}>
                <Typography className={classes.cardTitle}>
                    {title}
                </Typography>
                {Icon && (
                    <Icon
                        style={{
                            color: colors.icon,
                            fontSize: 20
                        }}
                    />
                )}
            </div>

            <Grid container spacing={1}>

                <Grid item xs={12}>

                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="text"
                        value={value}
                        multiline
                        onChange={changIdata("notes")}
                        className={classes.input}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">

                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
            </Grid>

        </Paper>

    );

};

// =====================================
// المكون الرئيسي
// =====================================

const InvoiceTotals = ({
    isPurches,
    setting,
    idata,
    valueType,
    uiElement,
    changIdata,
    isStock,
    isMake,
    permistionInv,
    changinvDisc,
    invDisc,
    changClick,
    payment,
    changPayment,
    sums,
    currentUserName,
    isHedden,
    permiCuCo,
    or,
    setFile,
    handleDownload,
    setFiles,
    files,
    db_name,
    changInvRe_Disc,
    valueCustomers,
    balance,
    setBalance,
    data = {},

}) => {
    const getBalances = async () => {
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `AccountReports/rptABalanceSum?branch=${-1}&&costCenter=${-1}
            &&acc_code=${valueCustomers.acc_no.toString()}`
        } else {
            Urls = `AccountReports/rptABalanceSum?branch=${-1}&&costCenter=${-1}
            &&acc_code=${valueCustomers.acc_no.toString()}&&db_name=${sto?.db_name}`
        }
        setBalance({ tot: 0, status: "" });
        await axios
            .get(
                uri + Urls
            )
            .then((res) => {
                if (res.data == null) {
                    setBalance(0);
                } else {
                    let i = {
                        dept: Number(res.data.end_Dept),
                        credit: Number(res.data.end_Credit),
                    };
                    let balane = i.dept > i.credit ? parseFloat(i.dept - i.credit).toFixed(2) : parseFloat(i.credit - i.dept).toFixed(2);
                    let status = i.dept > i.credit ? "مدين" : "دائن";
                    const newTotals = {
                        tot: balane,
                        status: status,
                    }
                    setBalance(newTotals);
                }
            })
            .catch((res) => {
                console.log("erro", res.error);
                setBalance({ tot: 0, status: "" });
            });
    };

    // const colors = SYSTEM_THEMES[type] || SYSTEM_THEMES.sales;
    const colors = setting.PrTy_InPr === "02" ? SYSTEM_THEMES.sales : ["01", "04", "11"].includes(setting.PrTy_InPr) ? SYSTEM_THEMES.purchases :
        setting.PrTy_InPr === "12" ? SYSTEM_THEMES.salesReturn : ["22", "33"].includes(setting.PrTy_InPr) ? SYSTEM_THEMES.openingStock :
            setting.PrTy_InPr === "03" ? SYSTEM_THEMES.qoutation : ["149", "150"].includes(setting.PrTy_InPr) ? SYSTEM_THEMES.eshar :
                SYSTEM_THEMES.sales;
    const classes = useStyles({ colors });
    const textfiles = files.map(x => x?.name).join("-");


    const { t } = useTranslation(["forms"]);
    // const claslbls = useStylesLbl();
    const [infoData, setInfoData] = useState({ open: false });

    const fileInputRef = useRef(null);

    const openFileDialog = () => {
        fileInputRef.current.click();
    };
    const [menPostion, setMenuPostion] = useState(null);
    const handleMultiFilesSelect = (event) => {
        const selected = Array.from(event.target.files);
        setFiles(selected);
    };

    const handleClickInLine = (e) => {
        e.preventDefault();
        setMenuPostion({
            x: e.pageX,
            y: e.pageY,
        });
    };

    const handleClickOutLine = () => {
        setMenuPostion(null);
    };

    return (
        <Paper
            className={classes.container} elevation={0}>
            <Grid container spacing={1.2}>
                {/* الصف الأول */}
                <Grid item xs={6} sm={4} md={3}>
                    <NotesCard
                        title={t("note")}
                        value={idata.notes}
                        changIdata={changIdata}
                        icon={Description}
                        colors={colors}
                    />
                </Grid>
                <Grid item xs={6} sm={4} md={2}>
                    <SummaryCard
                        title={t("remaining")}
                        value={payment.stay}
                        icon={AccessTime}
                        colors={colors}
                    />
                </Grid>
                <Grid item xs={6} sm={4} md={2}>
                    <TotalsCard
                        title={t("paid")}
                        name={"paidup"}
                        value={payment.paidup}
                        onchange={changPayment("paidup")}
                        icon={LocalAtm}
                        colors={colors}
                        disabled={valueType.id == 1 ? false : true}
                    />
                </Grid>
                <Hidden only={["xs"]}>
                    <Grid item xs={6} sm={4} md={1}>
                        <SummaryCard
                            title={t("total-quantity")}
                            value={sums.val1}
                            icon={LocalAtm}
                            colors={colors}
                        />
                    </Grid>
                </Hidden>
                <Hidden only={["xs"]}>
                    <Grid item xs={6} sm={4} md={2}>
                        <SummaryCard
                            title={["01", "11", "04"].includes(setting.PrTy_InPr) ? setting.priceTotNM : "إجمالي المبيعات"}
                            value={["01", "11", "04"].includes(setting.PrTy_InPr) ? idata.tot_purch : idata.tot_sale}
                            icon={TrendingUp}
                            colors={colors}
                        />
                    </Grid>
                </Hidden>
                <Grid item xs={6} sm={4} md={2}>
                    <SummaryCard
                        title={t("total_before_discount")}
                        value={idata.amountBefordisc}
                        icon={Store}
                        colors={colors}
                    />
                </Grid>
                {/* الصف الثاني */}
                <Hidden only={["xs"]}>
                    <Grid container item xs={6} sm={4} md={2}>
                        <Grid item lg={9} md={9} sm={12} xs={12} spacing={1}>
                            <Paper
                                className={classes.userCard}
                                elevation={0}
                            >
                                <Typography className={classes.userText}>
                                    {permiCuCo?.CWVtxt}
                                </Typography>

                                <Typography className={classes.userText}>
                                    المستخدم: {sto.usernames}
                                </Typography>
                                {files.length > 0 &&
                                    <Typography className={classes.userText}>
                                        {textfiles}
                                    </Typography>
                                }
                            </Paper>
                        </Grid>
                        <Hidden only={["xs"]}>
                            <Grid container item lg={2} md={or.postput == "toPut" ? 4 : 2} sm={4} xs={6} >
                                <Grid container item lg={6} md={4} sm={12} xs={12} spacing={1}>
                                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ padding: 10 }} >
                                        {or.postput == "toPut" && setting.PrTy_InPr !== "03"
                                            && setting.PrTy_InPr !== "04" && setting.PrTy_InPr !== "33" && (
                                                <Hidden only={"xs"}>
                                                    <Button
                                                        fullWidth
                                                        autoFocus
                                                        variant="contained"
                                                        onClick={(e) => {
                                                            setInfoData({ open: true, })
                                                        }}
                                                        style={{
                                                            ...{
                                                                paddingLeft: 0,
                                                                paddingRight: 0,
                                                            },
                                                        }}
                                                    >
                                                        {"القيد" + "  "}
                                                    </Button>
                                                </Hidden>
                                            )}
                                    </Grid>
                                    {permistionInv?.ARCHIVE === true && (
                                        <Grid item lg={6} md={6} sm={6} xs={6} style={{ padding: 10 }} >
                                            {or.postput == "toPost" ?
                                                (
                                                    <>
                                                        <Hidden smDown>
                                                            <Button
                                                                fullWidth
                                                                autoFocus
                                                                variant="contained"
                                                                onClick={(e) => {
                                                                    openFileDialog();
                                                                }}
                                                                style={{
                                                                    ...{
                                                                        paddingLeft: 0,
                                                                        paddingRight: 0,
                                                                    },
                                                                }}
                                                                startIcon={<CloudUpload />}
                                                            >
                                                                {"  "}
                                                            </Button>
                                                        </Hidden>
                                                        <input
                                                            type="file"
                                                            ref={fileInputRef}
                                                            multiple
                                                            style={{ display: "none" }}
                                                            onChange={handleMultiFilesSelect} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <Hidden smDown>

                                                            <Button
                                                                fullWidth
                                                                autoFocus
                                                                variant="contained"
                                                                color="#000"
                                                                onClick={(e) => {
                                                                    handleClickInLine(e);
                                                                }}
                                                                style={{
                                                                    ...{
                                                                        paddingLeft: 0,
                                                                        paddingRight: 0,
                                                                    },
                                                                }}
                                                                startIcon={<CloudUpload />}
                                                            >
                                                                {"  "}
                                                            </Button>
                                                        </Hidden>
                                                    </>
                                                )}
                                        </Grid>
                                    )}

                                </Grid>

                            </Grid>
                        </Hidden>
                        {menPostion && menuBottonsMultiFile(handleClickOutLine, openFileDialog, handleDownload, menPostion, fileInputRef, handleMultiFilesSelect)}
                    </Grid>
                </Hidden>

                <Grid item xs={6} sm={4} md={2}>
                    <SummaryCard
                        title={t("total_before_vat")}
                        value={idata.amountAfterDisc}
                        icon={Receipt}
                        colors={colors}
                    />
                </Grid>

                <Grid item xs={6} sm={4} md={2}>
                    <SummaryCard
                        title={t("total-value-add")}
                        value={idata.amountOfVat}
                        icon={CheckCircle}
                        colors={colors}
                    />
                </Grid>
                <Grid item xs={6} sm={4} md={2}>
                    <DiscountCard
                        title={permistionInv?.RE_DISC && ["02", "12"].includes(setting.PrTy_InPr) ? 
                            "خصم دفعة مقدمة" :t("discount-amount")}
                        amount={invDisc.minus}
                        percentage={invDisc.rate}
                        onAmountChange={changinvDisc("minus")}
                        onPercentageChange={changinvDisc("rate")}
                        changClick={changClick}
                        permistionInv={permistionInv}
                        isHedden={isHedden}
                        colors={colors}
                        icon={AccountBalanceWallet}
                    />

                </Grid>
                <Grid item xs={6} sm={4} md={2}>
                    <div className={classes.finalCard}>
                        <Hidden only={["xs"]}>
                            <MonetizationOn
                                style={{ fontSize: 43 }}
                            />
                        </Hidden>
                        <Typography className={classes.finalTitle}>
                            {t("net")}
                        </Typography>
                        <Typography className={classes.finalValue}>
                            {formatNumber(idata.netAmount)}
                        </Typography>

                    </div>

                </Grid>

                {permistionInv?.RE_DISC && ["02", "12"].includes(setting.PrTy_InPr) &&
                    <Grid item xs={6} sm={4} md={2}>
                        <DiscountCard
                            title="خصم ضمان"
                            amount={invDisc.re_disc_minus}
                            percentage={invDisc?.re_disc_rate}
                            onAmountChange={changInvRe_Disc("re_disc_minus")}
                            onPercentageChange={changInvRe_Disc("re_disc_rate")}
                            changClick={changClick}
                            permistionInv={permistionInv}
                            isHedden={isHedden}
                            colors={colors}
                            icon={Security}
                        />
                    </Grid>
                }
                {/* الصف الأخير */}
                {permistionInv?.SHOW_BALANCE &&

                    <Hidden only={"xs"}>
                        <Grid item xs={6} sm={3} md={2}>
                            <div className={classes.balanceCard}>
                                <Typography style={{ fontWeight: 800 }}>
                                    <Button
                                        fullWidth
                                        // className={classes.balanceButton}
                                        onClick={(event) => getBalances()}
                                    >
                                        <AccountBalance
                                            style={{
                                                marginLeft: 8,
                                                fontSize: 23
                                            }}
                                        />
                                        عرض الرصيد
                                    </Button>
                                </Typography>
                                <Typography
                                    style={{
                                        fontSize: 22,
                                        fontWeight: 900
                                    }}
                                >
                                    <div className="balance-card balance-blue">
                                        <strong>{Number(balance?.tot || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}{"  "}{balance?.status}</strong></div>
                                </Typography>

                            </div>

                        </Grid>
                    </Hidden>
                }



            </Grid>
            {or.postput == "toPut" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04"
                && setting.PrTy_InPr !== "33" && (
                    <RestInfoDialog
                        infoData={infoData}
                        setInfoData={setInfoData}
                        res_id={0}
                        branch={0}
                        fromInv={1}
                        proc_id={idata?.proc_id}
                        db_name={db_name}
                    />
                )}
        </Paper>

    );

};

export default InvoiceTotals;